import React, { useEffect, useState, useMemo } from "react";
import Modal from "react-modal";
import { toast } from "react-toastify";
import { AiOutlineClose, AiOutlineEdit, AiOutlineEye } from "react-icons/ai";
import SummaryApi from "../common";
import { useTable, usePagination } from "react-table";
import * as XLSX from "xlsx";
import { IoIosCloseCircle } from "react-icons/io";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";

const NotInterestedStudents = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [studentsData, setStudentsData] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [dropdownValue, setDropdownValue] = useState("");
  const [minEnrolledDate, setMinEnrolledDate] = useState(null);
  const [maxEnrolledDate, setMaxEnrolledDate] = useState(new Date());
  const [selectedRange, setSelectedRange] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [isCustomRange, setIsCustomRange] = useState(false);

  const [formData, setFormData] = useState({
    student_name: "",
    gender: "Male",
    father_name: "",
    mobile_number1: "",
    mobile_number2: "",
    email: "",
    aadhar_number: "",
    state: "",
    district: "",
    city: "",
    address: "",
    pincode: "",
    course: "",
    clg_name: "",
    program_type: "",
    department: "",
    ug_pg_course: "",
    call_back_reason: "",
    call_duration: "00:00:00.000000",
    other_reasons: "",
    is_interested: "",
    call_status: "",
    remarks: "",
    prev_call_back_reason: "",
    is_joined: "",
    joined_clg: "",
    hours: "00",
    minutes: "00",
    seconds: "00",
  });

  const [memberType, setMemberType] = useState(null);
  const [loading, setLoading] = useState(true);

  const [searchModalIsOpen, setSearchModalIsOpen] = useState(false);
  const [searchDistrict, setSearchDistrict] = useState("");
  const [searchCity, setSearchCity] = useState("");
  const [searchCollege, setSearchCollege] = useState([]);

  const headers = {
    Authorization: "Bearer indrashil_university_916",
    "Content-Type": "application/json",
  };

  const departmentsData = {
    UG: [
       "B.Pharma",
      "B.pharma in MLT",
      "B.Sc(Hons.) in BioScience",
      "B.Sc(Hons.) in Chemistry",,
    ],
  };

  const departments = useMemo(() => {
    if (
      !formData.program_type ||
      !departmentsData[formData.program_type] ||
      Array.isArray(departmentsData[formData.program_type])
    ) {
      return [];
    }
    return Object.keys(departmentsData[formData.program_type]);
  }, [formData.program_type]);

  const courses = useMemo(() => {
    if (!formData.program_type || !departmentsData[formData.program_type])
      return [];

    const programData = departmentsData[formData.program_type];
    if (Array.isArray(programData)) {
      return programData;
    }
    if (formData.department && programData[formData.department]) {
      return programData[formData.department];
    }
    return [];
  }, [formData.program_type, formData.department]);

  const fetchStudents = async () => {
    setLoading(true);
    try {
      const encodedMemberType = sessionStorage.getItem("K3M8X1JQ5VZ4B7PWTL9");
      const memberType = encodedMemberType ? atob(encodedMemberType) : null;
      setMemberType(memberType);

      let response;

      if (memberType === "Admin" || memberType === "Manager") {
        response = await fetch(SummaryApi.getAllNotInterestedStudents.url, {
          method: SummaryApi.getAllNotInterestedStudents.method,
          headers,
        });
      } else {
        const encodedEmployeeId = sessionStorage.getItem(
          "H7Z4L9VD2XK5JW8QRYT6"
        );
        if (!encodedEmployeeId) throw new Error("Employee ID not found");
        const decodedEmployeeId = atob(encodedEmployeeId);
        response = await fetch(SummaryApi.notInterestedStudents.url, {
          method: SummaryApi.notInterestedStudents.method,
          headers,
          body: JSON.stringify({ employee_id: decodedEmployeeId }),
        });
      }

      if (!response.ok) throw new Error("Failed to fetch data");
      const data = await response.json();
      const students = data?.data || [];
      setStudentsData(students);
      setFilteredStudents(students);
    } catch (error) {
      toast.error(`Error fetching students: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchStudents();
  }, []);

  const handleFilterChange = (filter) => {
    setSelectedFilter(filter);
    filterStudents(filter, searchQuery, selectedRange);
  };

  const filterStudents = (filter, search, range) => {
    let filtered = studentsData;
    const timeZone = "Asia/Kolkata";

    const formatToKolkata = (date) =>
      new Intl.DateTimeFormat("en-IN", {
        timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(date);

    if (filter !== "All") {
      if (filter === "JEE Mains") {
        filtered = filtered.filter(
          (student) => student.is_jee === "Jee Mains Results"
        );
      } else if (filter === "JEE Mains2") {
        filtered = filtered.filter(
          (student) => student.is_jee2 === "Jee Mains-2 Results"
        );
      }
    }

    const convertToKolkataDateString = (date) =>
      formatToKolkata(new Date(date));

    if (range === "today") {
      const todayFormatted = formatToKolkata(new Date());
      filtered = filtered.filter(
        (student) =>
          convertToKolkataDateString(new Date(student.created_date)) ===
          todayFormatted
      );
    } else if (range === "yesterday") {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      const yesterdayFormatted = formatToKolkata(yesterday);
      filtered = filtered.filter(
        (student) =>
          convertToKolkataDateString(new Date(student.created_date)) ===
          yesterdayFormatted
      );
    } else if (range === "thisWeek") {
      const today = new Date();
      const startOfWeek = new Date(today);
      startOfWeek.setDate(today.getDate() - today.getDay());
      startOfWeek.setHours(0, 0, 0, 0);
      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      endOfWeek.setHours(23, 59, 59, 999);
      filtered = filtered.filter((student) => {
        const studentDate = new Date(student.created_date);
        return studentDate >= startOfWeek && studentDate <= endOfWeek;
      });
    } else if (range === "lastWeek") {
      const today = new Date();
      const startOfCurrentWeek = new Date(today);
      startOfCurrentWeek.setDate(today.getDate() - today.getDay());
      startOfCurrentWeek.setHours(0, 0, 0, 0);
      const endOfLastWeek = new Date(startOfCurrentWeek);
      endOfLastWeek.setDate(startOfCurrentWeek.getDate() - 1);
      endOfLastWeek.setHours(23, 59, 59, 999);
      const startOfLastWeek = new Date(endOfLastWeek);
      startOfLastWeek.setDate(endOfLastWeek.getDate() - 6);
      startOfLastWeek.setHours(0, 0, 0, 0);
      filtered = filtered.filter((student) => {
        const studentDate = new Date(student.created_date);
        return studentDate >= startOfLastWeek && studentDate <= endOfLastWeek;
      });
    } else if (range === "custom" && fromDate && toDate) {
      const fromFormatted = new Date(fromDate);
      fromFormatted.setHours(0, 0, 0, 0);
      const toFormatted = new Date(toDate);
      toFormatted.setHours(23, 59, 59, 999);
      filtered = filtered.filter((student) => {
        const studentDate = new Date(student.created_date);
        return studentDate >= fromFormatted && studentDate <= toFormatted;
      });
    }

    if (search) {
      const lowercasedSearch = search.toLowerCase();
      filtered = filtered.filter(
        (student) =>
          student.student_name.toLowerCase().includes(lowercasedSearch) ||
          student.mobile_number1.toLowerCase().includes(lowercasedSearch) ||
          (["Admin", "Manager"].includes(memberType) &&
            student.employee_name.toLowerCase().includes(lowercasedSearch))
      );
    }
    setFilteredStudents(filtered);
  };

  useEffect(() => {
    if (studentsData?.length) {
      const dates = studentsData.map(
        (student) => new Date(student.created_date)
      );
      const minDate = new Date(Math.min(...dates));
      setMinEnrolledDate(minDate);
      setMaxEnrolledDate(new Date());
    }
  }, [studentsData]);

  const handleRangeChange = (e) => {
    const range = e.target.value;
    setSelectedRange(range);
    setIsCustomRange(range === "custom");
    if (range !== "custom") {
      setFromDate(null);
      setToDate(null);
      filterStudents(selectedFilter, searchQuery, range);
    } else {
      setFilteredStudents([]);
    }
  };

  useEffect(() => {
    if (fromDate && toDate) {
      filterStudents(selectedFilter, searchQuery, "custom");
    }
  }, [fromDate, toDate]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    filterStudents(selectedFilter, e.target.value, selectedRange);
  };

  const openModal = (student = null, mode = "view") => {
    const sanitizeStudentData = (data) => {
      const sanitizedData = { ...data };
      Object.keys(sanitizedData).forEach((key) => {
        if (sanitizedData[key] === "N/A") {
          sanitizedData[key] = "";
        }
      });
      return sanitizedData;
    };

    const payload = {
      ...formData,
      ...student,
      call_duration: student?.call_duration || "00:00:00.000000",
    };

    const sanitizedStudent = sanitizeStudentData(payload);

    let hours = "00",
      minutes = "00",
      seconds = "00";
    if (
      sanitizedStudent.call_duration &&
      typeof sanitizedStudent.call_duration === "string"
    ) {
      const [timePart] = sanitizedStudent.call_duration.split(".");
      if (timePart) {
        const parts = timePart.split(":");
        if (parts.length === 3) {
          [hours, minutes, seconds] = parts;
        }
      }
    }

    setFormData({
      ...sanitizedStudent,
      hours: hours.padStart(2, "0"),
      minutes: minutes.padStart(2, "0"),
      seconds: seconds.padStart(2, "0"),
    });

    const coursesArray = student?.ug_pg_course
      ? student.ug_pg_course.split(",").map((c) => c.trim())
      : [];
    setSelectedCourses(coursesArray);

    setIsUpdate(mode === "edit");
    setSelectedStudent(student);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedStudent(null);
    setIsUpdate(false);
    setFormData({
      student_name: "",
      gender: "Male",
      father_name: "",
      mobile_number1: "",
      mobile_number2: "",
      email: "",
      aadhar_number: "",
      state: "",
      district: "",
      city: "",
      address: "",
      pincode: "",
      course: "",
      clg_name: "",
      program_type: "",
      department: "",
      ug_pg_course: "",
      call_back_reason: "",
      call_duration: "00:00:00.000000",
      other_reasons: "",
      is_interested: "",
      call_status: "",
      remarks: "",
      prev_call_back_reason: "",
      is_joined: "",
      joined_clg: "",
      hours: "00",
      minutes: "00",
      seconds: "00",
    });
    setSelectedCourses([]);
  };

  const validateForm = () => {
    const { call_status, is_interested, call_back_reason, other_reasons } =
      formData;

    if (!isUpdate) return true;

    if (!call_status) {
      toast.warning("Please select a Call Status.");
      return false;
    }

    if (call_status === "Contacted") {
      if (
        ![
          "Not Interested",
          "Interested",
          "Most Interested",
          "Call Back",
          "Others",
        ].includes(is_interested)
      ) {
        toast.warning("Please select an interest level.");
        return false;
      }
      if (is_interested === "Call Back" && !call_back_reason) {
        toast.warning("Please select a Call Back reason.");
        return false;
      }
      if (is_interested === "Others" && !other_reasons) {
        toast.warning('Please select a reason for "Others".');
        return false;
      }
    }
    return true;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "call_status") {
      const resetState = {
        is_interested: "",
        call_back_reason: "",
        other_reasons: "",
        is_joined: "",
        joined_clg: "",
        program_type: "",
        department: "",
        ug_pg_course: "",
      };
      setFormData((prev) => ({ ...prev, ...resetState, [name]: value }));
      setSelectedCourses([]);
    } else if (name === "is_interested") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        ...(value !== "Call Back" && { call_back_reason: "" }),
        ...(value !== "Others" && { other_reasons: "" }),
      }));
    } else if (name === "program_type") {
      setSelectedCourses([]);
      setDropdownValue("");
      setFormData((prev) => ({
        ...prev,
        program_type: value,
        department: "",
        ug_pg_course: "",
      }));
    } else if (name === "department") {
      setSelectedCourses([]);
      setDropdownValue("");
      setFormData((prev) => ({ ...prev, department: value, ug_pg_course: "" }));
    } else if (name === "is_joined") {
      setFormData((prev) => ({
        ...prev,
        is_joined: value,
        ...(value !== "Already Joined" && { joined_clg: "" }),
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSelectChange = (e) => {
    const selectedCourse = e.target.value;
    if (selectedCourse && !selectedCourses.includes(selectedCourse)) {
      setSelectedCourses((prev) => [...prev, selectedCourse]);
    }
    setDropdownValue("");
  };

  const handleRemoveTag = (course) => {
    setSelectedCourses((prev) => prev.filter((c) => c !== course));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoadingSubmit(true);

    try {
      const encodedEmployeeId = sessionStorage.getItem("H7Z4L9VD2XK5JW8QRYT6");
      if (!encodedEmployeeId) throw new Error("Employee ID not found");
      const decodedEmployeeId = atob(encodedEmployeeId);

      const apiEndpoint = SummaryApi.updateStudent.url;
      const method = SummaryApi.updateStudent.method;

      const payloadData = {
        student_name: formData.student_name,
        last_name: formData.last_name,
        gender: formData.gender,
        father_name: formData.father_name,
        mobile_number1: formData.mobile_number1,
        mobile_number2: formData.mobile_number2 || "",
        email: formData.email || "",
        aadhar_number: formData.aadhar_number || "",
        state: formData.state,
        district: formData.district,
        city: formData.city,
        address: formData.address,
        pincode: formData.pincode || "",
        course: formData.course,
        clg_name: formData.clg_name,
        inter_percentage: formData.inter_percentage || "",
        program_type: formData.program_type,
        department: formData.department,
        ug_pg_course: selectedCourses.join(", "),
        call_status: formData.call_status || "",
        call_duration: `${formData.hours}:${formData.minutes}:${formData.seconds}`,
        remarks: formData.remarks || "",
        is_interested:
          formData.call_status === "Not Answered"
            ? ""
            : formData.is_interested === "Others"
            ? formData.other_reasons
            : formData.is_interested,
        call_back_reason: formData.call_back_reason || "",
        is_jee: formData.is_jee,
        is_jee2: formData.is_jee2,
        is_joined: formData.is_joined,
        joined_clg: formData.joined_clg,
      };

      const payload = {
        ...payloadData,
        student_id: selectedStudent.student_id,
        employee_id: decodedEmployeeId,
      };

      const response = await fetch(apiEndpoint, {
        method,
        headers,
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error("Network response was not ok");
      const result = await response.json();

      if (result.status) {
        toast.success("Student updated successfully!");
        closeModal();
        fetchStudents();
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    } finally {
      setLoadingSubmit(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "NA";
    const date = new Date(dateString);
    if (isNaN(date)) return "NA";
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const columns = React.useMemo(
    () => [
      { Header: "SNO", Cell: ({ row }) => row.index + 1 },
      ...(memberType === "Admin" || memberType === "Manager"
        ? [{ Header: "Employee Name", accessor: "employee_name" }]
        : []),
      { Header: "Enrollment Code", accessor: "enrollment_code" },
      { Header: "Student Name", accessor: "student_name" },
      { Header: "District", accessor: "district" },
      { Header: "City", accessor: "city" },
      { Header: "College Name", accessor: "clg_name" },
      { Header: "Mobile Number", accessor: "mobile_number1" },
      {
        Header: "Enrolled Date",
        accessor: "created_date",
        Cell: ({ value }) => formatDate(value),
      },
      {
        Header: "Follow Up Date",
        accessor: "follow_up_date",
        Cell: ({ value }) => formatDate(value),
      },
      {
        Header: "Current Status",
        accessor: "is_interested",
        Cell: ({ value }) => {
          let colorClass = "text-gray-600";
          if (value === "Most Interested") colorClass = "text-green-600";
          else if (value === "Interested") colorClass = "text-yellow-500";
          else if (value === "Not Interested") colorClass = "text-red-500";
          return (
            <span className={`font-semibold ${colorClass}`}>
              {value || "NA"}
            </span>
          );
        },
      },
      ...(memberType === "Employee" || memberType === "Consultant"
        ? [
            {
              Header: "Edit",
              Cell: ({ row }) => (
                <button
                  className="bg-green-600 text-white px-3 py-2 rounded-md hover:scale-105"
                  onClick={() => openModal(row.original, "edit")}
                >
                  <AiOutlineEdit className="inline-block mr-1" /> Edit
                </button>
              ),
            },
          ]
        : []),
      {
        Header: "View More",
        Cell: ({ row }) => (
          <button
            className="bg-yellow-600 text-white px-3 py-2 rounded-md hover:scale-105"
            onClick={() => openModal(row.original, "view")}
          >
            <AiOutlineEye className="inline-block mr-1" /> View
          </button>
        ),
      },
    ],
    [memberType]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state: { pageIndex, pageSize },
    canPreviousPage,
    canNextPage,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    pageCount,
  } = useTable(
    { columns, data: filteredStudents, initialState: { pageIndex: 0 } },
    usePagination
  );

  const clearFilters = () => {
    setSelectedRange("");
    setFromDate(null);
    setToDate(null);
    setIsCustomRange(false);
    setFilteredStudents(studentsData);
    setSearchQuery("");
    setSelectedFilter("All");
  };

  const collegeOptions = Array.from(
    new Set(
      filteredStudents
        .filter(
          (student) =>
            searchCity &&
            student.city?.toLowerCase() === searchCity.toLowerCase()
        )
        .map((student) => student.clg_name)
    )
  )
    .filter(Boolean)
    .map((college) => ({
      value: college,
      label: college,
    }));

  return (
    <div className="mx-auto">
      {loading ? (
        <div className="fixed inset-0 bg-black bg-opacity-70 z-20 flex justify-center items-center">
          <span className="text-white text-lg">Fetching Data...</span>
        </div>
      ) : (
        <>
          <div className="mx-auto">
            {loadingSubmit && (
              <div className="fixed inset-0 bg-black bg-opacity-70 z-20 flex justify-center items-center">
                <span className="text-white text-lg">Submitting...</span>
              </div>
            )}

            <div className="flex justify-between mb-6">
              <h1 className="text-3xl font-bold text-center">
                Not Interested Students
              </h1>
              <div>
                <button
                  onClick={() => setSearchModalIsOpen(true)}
                  className="bg-blue-500 text-white px-4 py-2 rounded-lg ml-4"
                >
                  Advanced Search
                </button>
              </div>
            </div>

            <div className="flex justify-between mb-4">
              {["Admin", "Manager"].includes(memberType) && (
                <div>
                  <label htmlFor="dateRange">Date Range:</label>
                  <select
                    id="dateRange"
                    className="bg-blue-500 py-2 px-4 text-white rounded-lg ml-4"
                    onChange={handleRangeChange}
                    value={selectedRange}
                  >
                    <option value="">Select</option>
                    <option value="today">Today</option>
                    <option value="yesterday">Yesterday</option>
                    <option value="thisWeek">This Week</option>
                    <option value="lastWeek">Last Week</option>
                    <option value="custom">Custom</option>
                  </select>
                  <button
                    onClick={clearFilters}
                    className="px-4 py-2 ml-4 bg-red-500 text-white rounded-lg hover:bg-red-600"
                  >
                    Clear
                  </button>
                  {isCustomRange && (
                    <div className="flex mt-4 gap-4">
                      <div>
                        <label>From:</label>
                        <DatePicker
                          selected={fromDate}
                          onChange={(date) => setFromDate(date)}
                          selectsStart
                          startDate={fromDate}
                          endDate={toDate}
                          minDate={minEnrolledDate}
                          maxDate={toDate || maxEnrolledDate}
                          dateFormat="dd-MM-yyyy"
                          placeholderText="From Date"
                          className="p-2 ml-2 border rounded-lg"
                        />
                      </div>
                      <div>
                        <label>To:</label>
                        <DatePicker
                          selected={toDate}
                          onChange={(date) => setToDate(date)}
                          selectsEnd
                          startDate={fromDate}
                          endDate={toDate}
                          minDate={fromDate || minEnrolledDate}
                          maxDate={maxEnrolledDate}
                          dateFormat="dd-MM-yyyy"
                          placeholderText="To Date"
                          className="p-2 ml-2 border rounded-lg"
                          disabled={!fromDate}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
              <div className="w-1/3">
                <input
                  type="text"
                  value={searchQuery}
                  onChange={handleSearchChange}
                  placeholder="Search by name, mobile, or employee..."
                  className="py-2 px-4 border rounded-lg w-full"
                />
              </div>
            </div>

            <div className="overflow-x-auto p-4">
              <table
                {...getTableProps()}
                className="min-w-full mb-4 rounded-lg shadow-md overflow-hidden"
              >
                <thead className="bg-gray-200">
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th
                          {...column.getHeaderProps()}
                          className="px-4 py-2 text-left text-gray-700 font-semibold"
                        >
                          {column.render("Header")}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {page.map((row) => {
                    prepareRow(row);
                    return (
                      <tr
                        {...row.getRowProps()}
                        className="hover:bg-gray-100 transition duration-200"
                      >
                        {row.cells.map((cell) => (
                          <td
                            {...cell.getCellProps()}
                            className="border px-4 py-2"
                          >
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <div className="flex justify-between items-center">
                <span>
                  Page {pageIndex + 1} of {pageCount} of{" "}  {filteredStudents.length} entries
                </span>
                 <div>
                  <button
                    onClick={() => gotoPage(0)}
                    disabled={!canPreviousPage}
                    className="px-3 py-1 border rounded"
                  >
                    {"<<"}
                  </button>
                  <button
                    onClick={previousPage}
                    disabled={!canPreviousPage}
                    className="px-3 py-1 border rounded"
                  >
                    {"<"}
                  </button>
                  <button
                    onClick={nextPage}
                    disabled={!canNextPage}
                    className="px-3 py-1 border rounded"
                  >
                    {">"}
                  </button>
                  <button
                    onClick={() => gotoPage(pageCount - 1)}
                    disabled={!canNextPage}
                    className="px-3 py-1 border rounded"
                  >
                    {">>"}
                  </button>
                </div>
                <select
                  value={pageSize}
                  onChange={(e) => setPageSize(Number(e.target.value))}
                >
                  {[10, 20, 50, 100].map((size) => (
                    <option key={size} value={size}>
                      Show {size}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <Modal
              isOpen={modalIsOpen}
              onRequestClose={closeModal}
              contentLabel="Student Details"
              className="mx-auto my-10 mt-[100px] max-h-[85vh] max-w-full sm:max-w-4xl bg-white rounded-lg shadow-lg overflow-auto"
              overlayClassName="fixed inset-0 bg-black bg-opacity-50"
            >
              <div className="sticky top-0 z-10 bg-white px-8 py-4 flex justify-between items-center border-b">
                <h2 className="text-2xl font-semibold">
                  {isUpdate ? "Edit Student" : "Student Details"}
                </h2>
                <button onClick={closeModal}>
                  <AiOutlineClose className="w-6 h-6" />
                </button>
              </div>
              <form
                onSubmit={handleSubmit}
                className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-8"
              >
                {/* Personal Details */}
                <div className="flex flex-col">
                  <label>Student Name</label>
                  <input
                    type="text"
                    name="student_name"
                    value={formData.student_name}
                    onChange={handleChange}
                    className="p-2 bg-slate-100 border rounded"
                    disabled={!isUpdate}
                  />
                </div>
                <div className="flex flex-col">
                  <label>Gender</label>
                  <select
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange}
                    className="p-2 bg-slate-100 border rounded"
                    disabled={!isUpdate}
                  >
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>
                <div className="flex flex-col">
                  <label>Father Name</label>
                  <input
                    type="text"
                    name="father_name"
                    value={formData.father_name}
                    onChange={handleChange}
                    className="p-2 bg-slate-100 border rounded"
                    disabled={!isUpdate}
                  />
                </div>
                <div className="flex flex-col">
                  <label>Mobile 1</label>
                  <input
                    type="tel"
                    name="mobile_number1"
                    value={formData.mobile_number1}
                    onChange={handleChange}
                    className="p-2 bg-slate-100 border rounded"
                    disabled={!isUpdate}
                    pattern="\d{10}"
                  />
                </div>
                <div className="flex flex-col">
                  <label>Mobile 2</label>
                  <input
                    type="tel"
                    name="mobile_number2"
                    value={formData.mobile_number2}
                    onChange={handleChange}
                    className="p-2 bg-slate-100 border rounded"
                    disabled={!isUpdate}
                    pattern="\d{10}"
                  />
                </div>
                <div className="flex flex-col">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="p-2 bg-slate-100 border rounded"
                    disabled={!isUpdate}
                  />
                </div>
                <div className="flex flex-col">
                  <label>Aadhar</label>
                  <input
                    type="text"
                    name="aadhar_number"
                    value={formData.aadhar_number}
                    onChange={handleChange}
                    className="p-2 bg-slate-100 border rounded"
                    disabled={!isUpdate}
                  />
                </div>
                <div className="flex flex-col">
                  <label>State</label>
                  <input
                    type="text"
                    name="state"
                    value={formData.state}
                    onChange={handleChange}
                    className="p-2 bg-slate-100 border rounded"
                    disabled={!isUpdate}
                  />
                </div>
                <div className="flex flex-col">
                  <label>District</label>
                  <input
                    type="text"
                    name="district"
                    value={formData.district}
                    onChange={handleChange}
                    className="p-2 bg-slate-100 border rounded"
                    disabled={!isUpdate}
                  />
                </div>
                <div className="flex flex-col">
                  <label>City</label>
                  <input
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    className="p-2 bg-slate-100 border rounded"
                    disabled={!isUpdate}
                  />
                </div>
                <div className="flex flex-col">
                  <label>Address</label>
                  <input
                    type="text"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    className="p-2 bg-slate-100 border rounded"
                    disabled={!isUpdate}
                  />
                </div>
                <div className="flex flex-col">
                  <label>Pincode</label>
                  <input
                    type="text"
                    name="pincode"
                    value={formData.pincode}
                    onChange={handleChange}
                    className="p-2 bg-slate-100 border rounded"
                    disabled={!isUpdate}
                  />
                </div>
                <div className="flex flex-col">
                  <label>College</label>
                  <input
                    type="text"
                    name="clg_name"
                    value={formData.clg_name}
                    onChange={handleChange}
                    className="p-2 bg-slate-100 border rounded"
                    disabled={!isUpdate}
                  />
                </div>
                <div className="flex flex-col">
                  <label>Inter %</label>
                  <input
                    type="text"
                    name="inter_percentage"
                    value={formData.inter_percentage}
                    onChange={handleChange}
                    className="p-2 bg-slate-100 border rounded"
                    disabled={!isUpdate}
                  />
                </div>
                <div className="flex flex-col">
                  <label>Course</label>
                  <input
                    type="text"
                    name="course"
                    value={formData.course}
                    onChange={handleChange}
                    className="p-2 bg-slate-100 border rounded"
                    disabled={!isUpdate}
                  />
                </div>

                {/* Call Status and Dependent Fields */}
                <div className="flex flex-col col-span-1 sm:col-span-2">
                  <label>
                    Call Status<span className="ml-1 text-red-600">*</span>
                  </label>
                  <select
                    name="call_status"
                    value={formData.call_status}
                    onChange={handleChange}
                    className="p-2 bg-slate-100 border rounded"
                    disabled={!isUpdate}
                    required
                  >
                    <option value="">Select</option>
                    <option value="Contacted">Contacted</option>
                    <option value="Not Answered">Not Answered</option>
                  </select>
                </div>
                 {/* <div className="flex flex-col col-span-1 sm:col-span-2">
                  <label>Join Status</label>
                  <select
                    name="is_joined"
                    value={formData.is_joined}
                    onChange={handleChange}
                    className="p-2 bg-slate-100 border rounded"
                    disabled={!isUpdate || formData.call_status !== "Contacted"}
                  >
                    <option value="">Select</option>
                    <option value="Already Joined">Already Joined</option>
                    <option value="Not Joined">Not Joined</option>
                  </select>
                </div>
                {formData.is_joined === "Already Joined" && (
                  <div className="flex flex-col">
                    <label>Joined College</label>
                    <input
                      type="text"
                      name="joined_clg"
                      value={formData.joined_clg}
                      onChange={handleChange}
                      className="p-2 bg-slate-100 border rounded"
                      disabled={!isUpdate}
                    />
                  </div>
                )} */}
                <div className="flex flex-col">
                  <label>Program Type</label>
                  <select
                    name="program_type"
                    value={formData.program_type}
                    onChange={handleChange}
                    className="p-2 bg-slate-100 border rounded"
                    disabled={!isUpdate || formData.call_status !== "Contacted"}
                  >
                    <option value="">Select</option>
                    {Object.keys(departmentsData).map((p) => (
                      <option key={p} value={p}>
                        {p}
                      </option>
                    ))}
                  </select>
                </div>
                {departments.length > 0 && (
                  <div className="flex flex-col">
                    <label>Department</label>
                    <select
                      name="department"
                      value={formData.department}
                      onChange={handleChange}
                      className="p-2 bg-slate-100 border rounded"
                      disabled={!isUpdate}
                    >
                      <option value="">Select</option>
                      {departments.map((d) => (
                        <option key={d} value={d}>
                          {d}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                <div className="flex flex-col">
                  <label>Interested Course(s)</label>
                  <select
                    value={dropdownValue}
                    onChange={handleSelectChange}
                    className="p-2 bg-slate-100 border rounded mb-2"
                    disabled={!isUpdate || courses.length === 0}
                  >
                    <option value="">Select</option>
                    {courses.map((c) => (
                      <option key={c} value={c}>
                        {c}
                      </option>
                    ))}
                  </select>
                  <div className="flex flex-wrap gap-2">
                    {selectedCourses.map((c) => (
                      <div
                        key={c}
                        className="flex items-center bg-blue-100 rounded-full px-3 py-1"
                      >
                        <span>{c}</span>
                        <button
                          type="button"
                          className="ml-2"
                          disabled={!isUpdate}
                          onClick={() => handleRemoveTag(c)}
                        >
                          <IoIosCloseCircle />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="flex flex-col col-span-1 sm:col-span-2">
                  <label>
                    Interest Level<span className="text-red-600">*</span>
                  </label>
                  <div className="flex flex-wrap gap-4">
                    {[
                      "Not Interested",
                      "Interested",
                      "Most Interested",
                      "Call Back",
                      "Others",
                    ].map((i) => (
                      <label key={i}>
                        <input
                          type="radio"
                          name="is_interested"
                          value={i}
                          checked={formData.is_interested === i}
                          onChange={handleChange}
                          className="mr-2"
                          disabled={
                            !isUpdate || formData.call_status !== "Contacted"
                          }
                          required
                        />
                        {i}
                      </label>
                    ))}
                  </div>
                </div>
                {formData.is_interested === "Call Back" && (
                  <div className="flex flex-col">
                    <label>
                      Call Back Reason<span className="text-red-600">*</span>
                    </label>
                    <select
                      name="call_back_reason"
                      value={formData.call_back_reason}
                      onChange={handleChange}
                      className="p-2 border rounded"
                      required
                    >
                      <option value="">Select</option>
                      <option value="Call Back">Call Back</option>
                      <option value="Counselling">Counselling</option>
                      <option value="EOD">EOD</option>
                    </select>
                  </div>
                )}
                {formData.is_interested === "Others" && (
                  <div className="flex flex-col">
                    <label>
                      Other Reason<span className="text-red-600">*</span>
                    </label>
                    <select
                      name="other_reasons"
                      value={formData.other_reasons}
                      onChange={handleChange}
                      className="p-2 border rounded"
                      required
                    >
                      <option value="">Select</option>
                      <option value="Wrong Number">Wrong Number</option>
                      <option value="Not Reachable">Not Reachable</option>
                      <option value="Number Not Working">
                        Number Not Working
                      </option>
                      <option value="Call Declined">Call Declined</option>
                      <option value="Busy">Busy</option>
                      <option value="Switched Off">Switched Off</option>
                      <option value="Incoming Calls Stopped">
                        Incoming Calls Stopped
                      </option>
                    </select>
                  </div>
                )}
                <div className="flex flex-col col-span-1 sm:col-span-2">
                  <label>Remarks</label>
                  <textarea
                    name="remarks"
                    value={formData.remarks}
                    onChange={handleChange}
                    className="p-2 bg-slate-100 border rounded"
                    disabled={!isUpdate}
                  />
                </div>
                {isUpdate && (
                  <div className="col-span-2">
                    <button
                      type="submit"
                      className="bg-blue-600 text-white px-4 py-2 rounded"
                      disabled={loadingSubmit}
                    >
                      {loadingSubmit ? "Updating..." : "Update"}
                    </button>
                  </div>
                )}
              </form>
            </Modal>

            <Modal
              isOpen={searchModalIsOpen}
              onRequestClose={() => setSearchModalIsOpen(false)}
              contentLabel="Search Filters"
              className="mx-auto my-10 mt-[100px] max-w-md bg-white rounded-lg shadow-lg"
              overlayClassName="fixed inset-0 bg-black bg-opacity-50"
            >
              <div className="p-6">
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-xl font-semibold">Search Filters</h2>
                  <button onClick={() => setSearchModalIsOpen(false)}>
                    <AiOutlineClose />
                  </button>
                </div>
                <div className="space-y-4">
                  <div className="flex flex-col">
                    <label>District</label>
                    <select
                      value={searchDistrict}
                      onChange={(e) => {
                        setSearchDistrict(e.target.value);
                        setSearchCity("");
                        setSearchCollege([]);
                      }}
                      className="p-2 border rounded"
                    >
                      <option value="">Select</option>
                      {[...new Set(studentsData.map((s) => s.district))]
                        .filter(Boolean)
                        .map((d) => (
                          <option key={d} value={d}>
                            {d}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="flex flex-col">
                    <label>City</label>
                    <select
                      value={searchCity}
                      onChange={(e) => {
                        setSearchCity(e.target.value);
                        setSearchCollege([]);
                      }}
                      className="p-2 border rounded"
                      disabled={!searchDistrict}
                    >
                      <option value="">Select</option>
                      {[
                        ...new Set(
                          studentsData
                            .filter((s) => s.district === searchDistrict)
                            .map((s) => s.city)
                        ),
                      ]
                        .filter(Boolean)
                        .map((c) => (
                          <option key={c} value={c}>
                            {c}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="flex flex-col">
                    <label>College</label>
                    <Select
                      isMulti
                      options={collegeOptions}
                      value={collegeOptions.filter((option) =>
                        searchCollege.includes(option.value)
                      )}
                      onChange={(selectedOptions) =>
                        setSearchCollege(
                          selectedOptions.map((option) => option.value)
                        )
                      }
                      isDisabled={!searchCity}
                      placeholder={
                        searchCity ? "Select College(s)" : "First select City"
                      }
                    />
                  </div>
                </div>
                <div className="flex justify-end pt-4">
                  <button
                    onClick={() => {
                      setSearchDistrict("");
                      setSearchCity("");
                      setSearchCollege([]);
                      setFilteredStudents(studentsData);
                    }}
                    className="px-4 py-2 mr-2 bg-gray-200 rounded"
                  >
                    Clear
                  </button>
                  <button
                    onClick={() => {
                      let filtered = studentsData.filter(
                        (s) =>
                          (!searchDistrict || s.district === searchDistrict) &&
                          (!searchCity || s.city === searchCity) &&
                          (searchCollege.length === 0 ||
                            searchCollege.includes(s.clg_name))
                      );
                      setFilteredStudents(filtered);
                      setSearchModalIsOpen(false);
                    }}
                    className="px-4 py-2 bg-blue-600 text-white rounded"
                  >
                    Apply
                  </button>
                </div>
              </div>
            </Modal>
          </div>
        </>
      )}
    </div>
  );
};

export default NotInterestedStudents;
